import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledWizardHintText = styled.span`
    ${setFontVariant("subsectionTitle", colorsPalettes.carbon[250])};
    font-weight: 400;
    font-style: normal;
    font-feature-settings: 'liga' off, 'clig' off;
`;

export const StyledWizardLinkButton = styled.span`
    ${setFontVariant("subsectionTitle", colorsPalettes.carbon[400])};
    font-weight: 700;
    font-style: normal;
    font-feature-settings: 'liga' off, 'clig' off;
    margin-left: 8px;
    cursor: pointer;

    &:hover {
        color: ${colorsPalettes.blue[400]};
    }
    &:active {
        color: ${colorsPalettes.blue[500]};
    }
`;